import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ItemNumberToFilter } from 'src/app/components/auth/models/interface/itemNumberToFilter.interface';
import { MuFieldPositionEnum } from 'src/app/components/shared/models/interface/muFieldPosition.enum';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { environment } from 'src/environments/environment';
import { AuthCompanyBillingActions } from '../../auth-company-billing.actions.enum';

@Component({
  selector: 'app-auth-company-billing-form',
  templateUrl: './auth-company-billing-form.component.html',
  styleUrls: ['./auth-company-billing-form.component.sass'],
})
export class AuthCompanyBillingFormComponent implements OnInit {
  @Input() loader: boolean;
  @Input() formData: UntypedFormGroup;
  @Input() documentTypeList: ItemNumberToFilter[];
  @Input() cityList: ItemNumberToFilter[];
  @Input() segmentationList: ItemNumberToFilter[];
  @Input() isMX: boolean;
  @Input() actionList: Actions<AuthCompanyBillingActions, any>;
  @Input() registerAction: AuthCompanyBillingActions;
  fieldPositionEnum = MuFieldPositionEnum;

  constructor() {
    //
  }

  ngOnInit(): void {
    //
  }

  /**
   * emit event register
   */
  register(): void {
    if (this.formData.get('isInvalidForm').value) {
      return environment.guardClause;
    }
    this.actionList.emit(this.registerAction, null);
  }
}
